import Accordion, { Row } from "@storeblocks/accordion";

import { useTexts } from "Components/TextContext";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import React from "react";
import ReactMarkdown from "react-markdown";
import { AlreadyInsuredWrapper } from "./styled";

interface Props {
  insuranceType: string;
}

export const AlreadyInsured = ({
  insuranceType,
}: Props): React.ReactElement | null => {
  const { getText } = useTexts();
  const featureToggleAlreadyInsured = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_881_ALREADY_INSURED,
  );

  if (!featureToggleAlreadyInsured) {
    return null;
  }

  return (
    <AlreadyInsuredWrapper>
      <Accordion>
        <Row
          id={`advicepage.cardadvicealreadyinsured.${insuranceType}`}
          header={getText("advicepage.cardadvicealreadyinsuredheader")}
          headerProps={{ type: "button" }}
          content={
            <ReactMarkdown linkTarget="_blank">
              {getText("advicepage.cardadvicealreadyinsuredtext", {
                variables: { adviceInsurance: insuranceType },
              })}
            </ReactMarkdown>
          }
        />
      </Accordion>
    </AlreadyInsuredWrapper>
  );
};
